import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import {
  getNowUseSystemLoginCheckWeb,
  LoginCheckMainWeb,
} from "../../../../../Api/ApiLoginCheckWeb";
import { authType } from "../../../../../pages/Login";
import LineBtn from "../../../../Button/LineBtn";
import AlertModal from "../../../../Modal/AlertModal";
import ContentLoader from "../../../../DefaultStyles/ContentLoader";
import { GetSubscriptionSetData } from "../../../../../ApiTS/ServiceDatasTS";
import ReportPartyValidCheckResultModal from "../../../Manage/LoginCheck/ReportPartyListSection/ReportPartyValidCheckResultModal";
import { useApi } from "../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../DefaultStyles/Loader";

interface LoginCheckBtnProps {
  subsId?: number;
  accountInfo?: {
    id: string;
    idType: string;
    profileName: string;
    ldrPday: string;
    agList: [];
  };
  passwordInfo?: {
    pw: string;
    adltPw: string;
  };
  partyId?: number;
}

export default function LoginCheckBtn({
  accountInfo,
  passwordInfo,
  subsId,
  partyId,
}: LoginCheckBtnProps) {
  // debugger;
  const auth = useRecoilValue(authType);
  const [useLoginCheck, setUseLoginCheck] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [resultModal, setResultModal] = useState(false);
  const [checkResult, setCheckResult] = useState({
    isValid: false,
    hasMembership: false,
    needCheck: false,
    addInfo: "",
  });
  const [saveErrParty, setSaveErrParty] = useState(false);
  const [failModal, setFailModal] = useState(false);

  console.log(accountInfo);
  console.log(passwordInfo);

  const { response, loading } = useApi({
    method: "post",
    url: saveErrParty ? `temp-account/saveErrParty` : undefined,
    data: {
      partyid: partyId ?? 0,
      wrong: checkResult?.needCheck
        ? 4
        : !checkResult?.hasMembership && checkResult?.isValid
        ? 2
        : 1,
    },
  });

  const isValidAccount = async () => {
    setIsLoading(true);
    const { isValid, hasMembership, needCheck, addInfo } =
      await LoginCheckMainWeb(
        subsId,
        accountInfo?.id?.replace(/(\s*)/g, ""),
        passwordInfo?.pw,
        accountInfo?.idType
      );

    // 응답이 있을 경우만
    setTimeout(() => {
      if (
        isValid !== undefined &&
        hasMembership !== undefined &&
        needCheck !== undefined
      ) {
        setCheckResult({
          isValid,
          hasMembership,
          needCheck,
          addInfo,
        });

        setResultModal(true);
      }
      setIsLoading(false);
    }, 1500);
  };

  useEffect(() => {
    if (subsId) {
      const checkIsUsingLoginCheck = async () => {
        let isUsingLoginCheck = await getNowUseSystemLoginCheckWeb(subsId);

        // 디즈니면 임시개방
        if (subsId === 5000 || subsId === 5001) {
          isUsingLoginCheck = true;
        }
        setUseLoginCheck(isUsingLoginCheck ? true : false);
      };

      checkIsUsingLoginCheck();
    }
  }, [subsId]);

  useEffect(() => {
    if (response?.status === 201) {
      toast.success("코멘트 등록, 블랙리스트 등재에 성공하였습니다.");
    }
  }, [response]);

  return (
    <>
      <LineBtn
        btnText="로그인 체크"
        btnClickEvent={() => {
          if (accountInfo && passwordInfo) {
            isValidAccount();
          }
        }}
        disabled={
          !(accountInfo && passwordInfo) ||
          accountInfo?.idType === "페이스북" ||
          accountInfo?.idType === "T계정" ||
          accountInfo?.idType === "T ID" ||
          accountInfo?.idType === "네이버" ||
          accountInfo?.idType === "리디" ||
          accountInfo?.idType === "CJ ONE" ||
          !auth?.partyInfo ||
          // !(state === 1 || state === 2 || state === 4) ||
          !useLoginCheck
        }
      />

      {resultModal && (
        <ReportPartyValidCheckResultModal
          partyId={partyId}
          checkResult={checkResult}
          confirmEvent={() => {
            console.log(checkResult);
            if (
              checkResult?.needCheck ||
              !checkResult?.isValid ||
              !checkResult?.hasMembership
            ) {
              setFailModal(true);
              setResultModal(false);
            } else {
              setResultModal(false);
            }
          }}
          closeEvent={() => setResultModal(false)}
        />
      )}

      {failModal &&
        (checkResult?.needCheck ||
          (checkResult?.isValid && !checkResult?.hasMembership) ||
          !checkResult?.isValid) && (
          <AlertModal
            title={`${
              checkResult?.needCheck
                ? "2차 인증이 필요합니다."
                : !checkResult?.hasMembership && checkResult?.isValid
                ? "이용권이 결제되지 않았습니다."
                : "공유 로그인 정보가 틀렸습니다."
            }\n코멘트 등록, 블랙리스트 등재를 하시겠습니까?`}
            cancelEvent={() => setFailModal(false)}
            confirmEvent={() => {
              setFailModal(false);
              setSaveErrParty(true);
            }}
          />
        )}

      {isLoading && (
        <ContentLoader title={`${partyId} 파티의 유효성 체크를 진행합니다.`} />
      )}

      {loading && <Loader />}
    </>
  );
}
